import { render, staticRenderFns } from "./MainAsWidget.vue?vue&type=template&id=b6288268&scoped=true"
import script from "./MainAsWidget.vue?vue&type=script&lang=js"
export * from "./MainAsWidget.vue?vue&type=script&lang=js"
import style0 from "./MainAsWidget.vue?vue&type=style&index=0&id=b6288268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6288268",
  null
  
)

export default component.exports